import React from 'react'
import { l, SearchInput } from '@manychat/manyui'

export const FancyInput = React.forwardRef<HTMLInputElement>((props, ref) => (
  <div className="p-relative p-a-xs b-b">
    <SearchInput inputRef={ref} {...props} ariaLabel={l.translate('Account search')} />
  </div>
))
